export default "__VITE_ASSET__4af77b77__"